module.exports = __webpack_public_path__ + "static/make-video-slide2@2x-63ee9a0e7efb7e1333cc2434d6c682af.png";